import React, { useState, useEffect } from 'react';
import MarkdownContent from '../components/MarkdownContent';
import { loadSectionContent, getPersonalInfo } from '../utils/contentLoader';

function Resume() {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const personalInfo = getPersonalInfo();
  
  useEffect(() => {
    // Set page title
    document.title = `${personalInfo.name || 'Personal Website'} - Résumé`;
    
    // Load content for resume page sections
    const loadContent = async () => {
      try {
        const loadedSections = await loadSectionContent('resume');
        setSections(loadedSections);
      } catch (error) {
        console.error('Error loading resume page content:', error);
      } finally {
        setLoading(false);
      }
    };
    
    loadContent();
    
    return () => {
      // Reset title when component unmounts
      document.title = personalInfo.name || 'Personal Website';
    };
  }, [personalInfo.name]);
  
  if (loading) {
    return (
      <div className="page-loading">
        <div className="loading-spinner"></div>
        <span>Loading...</span>
      </div>
    );
  }
  
  return (

    <div className="resume-page">
      <div className="container">
        <div className="resume-content">
          <h1>Résumé</h1>
          
          {sections.map((section, index) => (
            <section key={index} className={`resume-section ${section.id || ''}`}>
              {/* Section titles will come from the markdown content */}
              <MarkdownContent content={section.content} />
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Resume;
